import styled from 'styled-components';

const Container = styled.div`
    background-color: #F2F2F2;
    width: 375px;
    padding: 0 15px 110px;

    .loading {
        font-size: 20px;
        color: #666666;
        margin-top: 50px;
        text-align: center;
    }
`

export default Container;